// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".CommonDialog__errCode___1gmYk{display:flex;font-weight:bolder;padding-top:23px;z-index:9999999}", ""]);
// Exports
exports.locals = {
	"errCode": "CommonDialog__errCode___1gmYk"
};
module.exports = exports;
